import React from 'react';
import '../template-file-css/document-file-template.css';


export const ROC_PermissionToBill = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='ROC_PermissionToBill' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <center> Permission to Bill the Insurance Company </center> </p>
                <p className='w-750'>
                    I,

                    <input type='text' id='txtPermissionAcknowledge' name='txtPermissionAcknowledge' className='add-only w-250 custom-add-only' />

                    authorize staff and the representatives of Restore Outreach Center, LLC to bill the appropriate insurance company for services provided to me.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Consumer</td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp;
                        </td>
                        <td className='signature w-375'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Witness Signature </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}